import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useFamily } from '@/context/FamilyContext';
import { FullPageLoader } from './LoadingSpinner';
import { ReactNode } from 'react';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function RequireFamily({ children }: { children: ReactNode }) {
  const { user, loading: authLoading } = useAuth();
  const { family, loading: famLoading } = useFamily();

  if (authLoading || famLoading) return <FullPageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!family) return <Navigate to="/create-family" replace />;
  return <>{children}</>;
}
